var map = {
	"./Fabbrica.jpg": 5082,
	"./FlagIT.png": 7548,
	"./FlagUK.png": 8402,
	"./Home": 869,
	"./Home/": 869,
	"./Home/foto1.png": 7713,
	"./Home/foto2.png": 9889,
	"./Home/foto3.png": 5784,
	"./Home/index": 869,
	"./Home/index.js": 869,
	"./Home/prodotti1.PNG": 1226,
	"./Home/prodotti2.PNG": 4670,
	"./Home/prodotti3.PNG": 1314,
	"./Home/prodotti4.PNG": 7529,
	"./StandardImage.jpeg": 7830,
	"./altrigiochi/Orbit.png": 5866,
	"./altrigiochi/Orbit1.png": 519,
	"./altrigiochi/Shuff.9'.jpg": 9901,
	"./altrigiochi/Shuff.9lat.jpg": 6488,
	"./altrigiochi/Shuff12.jpg": 4828,
	"./altrigiochi/Shuff12lat.jpg": 5680,
	"./altrigiochi/air-hockey-table.jpg": 9245,
	"./altrigiochi/aladin 4.jpg": 3654,
	"./altrigiochi/aladin cop 1.jpg": 6658,
	"./altrigiochi/particolare divisorio.jpg": 4057,
	"./altrigiochi/particolare-divisorio-2.jpg": 1162,
	"./altrigiochi/ping-pong-orbit-dettaglio.jpg": 8391,
	"./altrigiochi/puck.JPG": 9779,
	"./altrigiochi/puck1.JPG": 1345,
	"./altrigiochi/puck2.JPG": 1445,
	"./biliardi/Aladin 5.jpg": 5346,
	"./biliardi/Seahawk.png": 9871,
	"./biliardi/aladin 4.jpg": 2067,
	"./biliardi/aladin cop 1.jpg": 2425,
	"./biliardi/charleston1.png": 3836,
	"./biliardi/charleston2.png": 8088,
	"./biliardi/charleston3.png": 196,
	"./biliardi/charleston4.png": 2988,
	"./biliardi/charleston5.png": 8506,
	"./biliardi/eagle1.png": 3422,
	"./biliardi/eagle2.png": 6048,
	"./biliardi/eagle3.png": 8756,
	"./biliardi/eagle4.png": 9776,
	"./biliardi/eagle5.png": 7274,
	"./biliardi/old/Seahawk1.jpg": 2110,
	"./biliardi/old/Seahawk2.jpg": 2564,
	"./biliardi/old/charleston1.jpg": 6926,
	"./biliardi/old/charleston2.jpg": 9801,
	"./biliardi/old/charleston3.jpg": 2417,
	"./biliardi/old/charleston4.jpg": 7030,
	"./biliardi/old/charleston5.jpg": 3716,
	"./biliardi/old/charleston6.jpg": 165,
	"./biliardi/old/charleston7.jpg": 1381,
	"./biliardi/old/charleston8.jpg": 1617,
	"./biliardi/old/charleston9.jpg": 3315,
	"./biliardi/old/eagle1.jpg": 8907,
	"./biliardi/old/eagle2.jpg": 5576,
	"./biliardi/old/eagle3.jpg": 7476,
	"./biliardi/old/eagle4.jpg": 7279,
	"./biliardi/old/eagle5.jpg": 2214,
	"./biliardi/old/pierrot1.jpg": 2714,
	"./biliardi/old/pierrot2.jpg": 3004,
	"./biliardi/old/pierrot3.jpg": 6527,
	"./biliardi/old/pierrot4.jpg": 8045,
	"./biliardi/old/poolnera.jpg": 5370,
	"./biliardi/old/venus1.jpg": 6140,
	"./biliardi/old/venus2.jpg": 5461,
	"./biliardi/old/venus3.jpg": 6350,
	"./biliardi/pierrot1.png": 8710,
	"./biliardi/pierrot2.png": 3620,
	"./biliardi/pierrot3.png": 7484,
	"./biliardi/pierrot4.png": 4944,
	"./biliardi/pool-americano-camping.jpg": 5665,
	"./biliardi/poolnera.png": 1370,
	"./biliardi/venus1.png": 7378,
	"./biliardi/venus2.png": 8090,
	"./biliardi/venus3.png": 394,
	"./calciobalilla/ATLANTIS BIANCO NO SFONDO.jpg": 2864,
	"./calciobalilla/Atlantis Lux Maul 1.jpg": 4852,
	"./calciobalilla/Atlantis Lux nero 1.jpg": 6789,
	"./calciobalilla/Atlantis Lux rosso.jpg": 3778,
	"./calciobalilla/Atlantis lux blu 1.jpg": 1702,
	"./calciobalilla/Hermes 1.jpg": 3326,
	"./calciobalilla/HermesWhite2.jpg": 3731,
	"./calciobalilla/Hobby.JPG": 2954,
	"./calciobalilla/Outdoor.png": 7216,
	"./calciobalilla/Phenix nero no sfondo.jpg": 1944,
	"./calciobalilla/Standard-coperto.jpg": 3477,
	"./calciobalilla/TamTam1.JPG": 7048,
	"./calciobalilla/TamTam2.jpg": 8903,
	"./calciobalilla/Tamfronte.JPG": 434,
	"./calciobalilla/aladin 4.jpg": 2273,
	"./calciobalilla/aladin cop 1.jpg": 2730,
	"./calciobalilla/ares border.jpg": 971,
	"./calciobalilla/ares-calcio-balilla.jpg": 1728,
	"./calciobalilla/atlantis-bianco-nuovo.jpg": 4414,
	"./calciobalilla/calcio-balilla-atlantis-min.jpg": 7738,
	"./calciobalilla/calcio-balilla-flash.jpg": 6006,
	"./calciobalilla/calcio-balilla-gazzetta-dello-sport.jpg": 8725,
	"./calciobalilla/calcio-balilla-millennium.jpg": 7443,
	"./calciobalilla/calcio-balilla-moderno-hermes.jpg": 3514,
	"./calciobalilla/calcio-balilla-premier-league.jpg": 5851,
	"./calciobalilla/calcio-balilla-stile-retro.jpg": 1400,
	"./calciobalilla/faxe bianco ns.jpg": 5700,
	"./calciobalilla/faxe.jpg": 1514,
	"./calciobalilla/flash fianco.jpg": 3610,
	"./calciobalilla/flash sopra.jpg": 6371,
	"./calciobalilla/hobby red.jpg": 9265,
	"./calciobalilla/particolare campo gioco-outd.jpg": 4054,
	"./calciobalilla/particolare outdoor.jpg": 7306,
	"./calciobalilla/phenix-bianco-alaska.jpg": 7424,
	"./calciobalilla/phenix-blu-fes.jpg": 5841,
	"./calciobalilla/phenix-rosso-jaipur.jpg": 3284,
	"./calciobalilla/phenix-verde-comodoro.jpg": 3073,
	"./calciobalilla/porta-outdoor.JPG": 3457,
	"./calciobalilla/premier-league.jpg": 3919,
	"./calciobalilla/pride-coperto.jpg": 8207,
	"./calciobalilla/pride-raster.jpg": 1927,
	"./calciobalilla/pride.png": 4338,
	"./calciobalilla/pridenosfondo.jpg": 806,
	"./calciobalilla/sardisport.png": 3094,
	"./calciobalilla/speedy 2 testata gialla.jpg": 8044,
	"./calciobalilla/speedy mog.JPG": 1003,
	"./calciobalilla/speedy web.jpg": 944,
	"./calciobalilla/standard.jpg": 8363,
	"./calciobalilla/tamtaprog.jpg": 8707,
	"./calciobalilla/twister.jpg": 7958,
	"./calciobalilla/xl.jpg": 8475,
	"./coppi.jpg": 3718,
	"./heiku.jpg": 8659,
	"./logon.png": 3205,
	"./novo-parts.jpg": 539,
	"./omino copia.png": 1021,
	"./omino.png": 995,
	"./ominogirato.png": 7223,
	"./personalizzazioni/albani.jpg": 4504,
	"./personalizzazioni/aperol.jpg": 504,
	"./personalizzazioni/ares-champions.jpg": 1205,
	"./personalizzazioni/cescon.jpg": 1802,
	"./personalizzazioni/coca-cola.jpg": 3347,
	"./personalizzazioni/continental.jpg": 788,
	"./personalizzazioni/gatorade.jpg": 310,
	"./personalizzazioni/gazzetta.jpg": 9951,
	"./personalizzazioni/holland.jpg": 4209,
	"./personalizzazioni/johnpitstop.jpg": 8264,
	"./personalizzazioni/kenzo.jpg": 5534,
	"./personalizzazioni/konig-pilsener.jpg": 2591,
	"./personalizzazioni/pepsiboom.jpg": 6895,
	"./personalizzazioni/ricreativo.jpg": 7317,
	"./personalizzazioni/ringo.jpg": 2188,
	"./personalizzazioni/sassuolo.jpg": 5295,
	"./personalizzazioni/skyvr46.jpg": 9483,
	"./rockandgoal.jpg": 465,
	"./s.png": 9323,
	"./sardi-sport.jpg": 425,
	"./sportfoot.jpg": 5165,
	"./stabilimento.jpg": 7421,
	"./ungheria.jpg": 4514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1931;